import { t } from "i18next";
import DBModal from "../../component/global/DBModal";
import DBButton from "../../component/global/DBButton";
import CampaignRecipientsSection from "./CampaignRecipientsSection";

export default function RecipientsModal({ campaign, onHide, onChange }) {
    return (
        <DBModal
            permanent
            show
            minWidth={640}
            onHide={onHide}
            className="survey-form-modal campaign-modal recipients-only-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                title={t("survey.recipients.title")}
            />
            <DBModal.Content>
                <CampaignRecipientsSection
                    campaign={campaign}
                    onChange={onChange}
                    showHeader={false}
                />
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("cancel")}
                    type="secondary"
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
